import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import financialTransactionsApi from '@/features/dashboard/financialTransactions/api/financialTransactionsApi.ts';
import { invalidateFinanceRelatedQueries } from '@/utils/invalidateFinanceQueries.ts';

const useDeleteFinancialTransaction = () => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, string>({
    mutationFn: (id) => financialTransactionsApi.delete(id),
    onSuccess: () => {
      toast.success('Transakcja została usunięta');
      invalidateFinanceRelatedQueries(queryClient);
    },
    onError: (error: Error) => {
      toast.error('Nie udało się usunąć transakcji', {
        description: error.message,
      });
    },
  });
};

export default useDeleteFinancialTransaction;
